import React from 'react'; // eslint-disable-line
import i18n from '../../i18n';
import CloseModal from '../svg/CloseX2';

const YesNoDialog = (props) => {
    return (
        <div data-qa={`${props.DataQA}-${props.Visible ? 'show' : 'hidden'}`} className={`dialog-overlay ${props.Visible ? 'dialog-show' : 'dialog-hide'}`}>
            <div className="small-modal dialog-content">
                {/* eslint-disable-next-line */}
                <div className="modal-header">
                    {/* eslint-disable-next-line */}
                    <a
                        aria-label="Close"
                        data-qa={`${props.DataQA}-close-x`}
                        className="close-dialog"
                        onClick={props.CloseDialog}
                    >
                        <CloseModal />
                    </a>
                    <h3
                        data-qa="modal-header"
                    >
                        {props.title}
                    </h3>
                </div>
                <div className="modal-body">
                    {props.Message}
                    <div className="btn-wrap-modal-body">
                        {/* eslint-disable-next-line */}
                        <a className="btn-design-system warning" data-qa={`${props.DataQA}-save-yes`} onClick={props.ExecuteAction}>{props.YesText ? props.YesText : i18n.t('yes')}</a>
                        {/* eslint-disable-next-line */}
                        <a className="btn-design-system secondary" data-qa={`${props.DataQA}-cancel-no`} onClick={props.CloseDialog}>{props.NoText ? props.NoText : i18n.t('no')}</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default YesNoDialog;
